<template>
  <v-container fluid>
    <v-row justify="center">
      <h2>{{ $t('title') }}</h2>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "HallOfFameFutures"
}
</script>

<style scoped>

</style>

<i18n>
{
  "en": {
    "title": "Top traders from Futures market"
  },
  "es": {
    "title": "Mejores traders del mercado de  Futuros"
  }
}
</i18n>
